<template>
  <div>
    <el-dialog top="calc( 50vh - 150px )"
               :visible.sync="dialogTemplateVisible"
               width="70vw"
               :show-close='false'
               :close-on-click-modal='false'
               :fullscreen="false"
               v-loading="isLoading"
               class="select-template-dialog"
    >
      <div class="main-content" :style="{ backgroundImage: 'url(' + contHearerBg + ')' }">
        <div class="header-icon"><i class="el-icon-close" @click="handleClose"></i></div>
        <div class="contentHeader">
          <div class="main-title">小智透视</div>
          <div class="tab-main">
            <div class="tab-item">
              <div v-for="(item, index) in arrTab" :key="index" :class="item.active ? 'tab active' : 'tab'"
                   @click="changeTab(item.value)">
                <div class="txt">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="search-area" style="display: flex;">
            <!--                        <el-autocomplete
                                        class="cursearch"
                                        popper-class="search-item"
                                        v-model="viewValue"
                                        :fetch-suggestions="querySearch"
                                        :trigger-on-focus="false"
                                        placeholder="请输入关键字:主体(上市公司、企业),主题(财务报告、年报),或者市场(深主板、银行间)等"
                                        @select="handleSelect"
                                        @clear="onValueClear"
                                        @change="onChange"
                                    >
                                        <template slot-scope="{ item }">
                                            <div class="name">
                                                <span>{{ item.label }}</span>
                                                <el-tag v-if="item.placeTag">{{ item.placeTag }}</el-tag>
                                                <el-tag v-if="item.plateTag">{{ item.plateTag }}</el-tag>
                                                <el-tag v-if="item.firstTypeTag">{{ item.firstTypeTag }}</el-tag>
                                            </div>
                                        </template>
                                    </el-autocomplete>-->
            <el-select v-model="tplSelected" placeholder="请选择">
              <el-option
                  v-for="item in readerTpls"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
              </el-option>
            </el-select>
            <el-button class="search-btn" type="primary" @click="pageFinished"
                       :disabled="!hasGoPageAuth && tplSelected.length <= 0">进入透视
            </el-button>
          </div>

          <!--                    <el-row class="hotsearch">
                                  <el-col class="title" :span="2">
                                      <div>推荐</div>
                                      <div>模板</div>
                                  </el-col>
                                  <el-col class="keys" :span="22">
                                      <div v-show="curTab == 'devTemplate'">
                                          <el-link v-for="(item, index) in hotDevTemplates" :key="index" @click="btnHotpageTo(item)">{{ item.label
                                          }}</el-link>
                                      </div>
                                  </el-col>
                              </el-row>
                              <el-row class="hotsearch">
                                  <el-col class="title" :span="2">
                                      <div>历史</div>
                                      <div>搜索</div>
                                  </el-col>
                                  <el-col class="keys" :span="22">
                                      <div v-show="curTab == 'devTemplate'">
                                          <el-link v-for="(item, index) in devTemplateHistoryList" :key="index" @click="btnHistoryPageTo(item)">{{
                                              item.label
                                          }}</el-link>
                                      </div>
                                  </el-col>
                              </el-row>-->

        </div>
      </div>
    </el-dialog>
    <iframe v-if="!dialogTemplateVisible && readerSrc?.length > 0" :src="readerSrc" class="reader-box" frameborder="0px"></iframe>
  </div>
</template>


<script>
import contHearerBg from "@/assets/img/bigScreen/bg1.jpg";
import apiAxios from "@/config/apiAxios";
import userDocApi from "../../assets/js/userDocApi";

export default {
  name: 'selectTemplateDialog',
  components: {},
  props: {},
  data() {
    return {
      viewValue: '',
      isLoading: true,
      dialogTemplateVisible: true,
      contHearerBg: contHearerBg,
      arrTab: [
        {"name": "透视模板", "active": true, "value": "devTemplate", "placeholder": "请输入模板名称", "lexicon": "label"},
      ],
      curLexicon: "label",
      curTab: 'devTemplate',
      hotDevTemplates: [],
      curSelect: {},
      devTemplateHistoryList: localStorage.getItem('templatesHistory') || [],
      templateName: '',
      raw: {},
      hasGoPageAuth: false,
      readerTpls: [],
      tplSelected: "",
      readerSrc : false,
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    onChange(val) {
      this.hasGoPageAuth = false;
    },
    /**
     * 输入框辅助提示
     * @param queryString
     * @param cb
     */
    querySearch(queryStr, cb, res) {
      // console.log("进入搜索：",queryStr);
      let params = {
        path: 'usys/factory/factor/template/release',
        tags: ['tech_sbom'],
        matchesPattern: ''
      }
      if (queryStr != '') {
        params.matchesPattern = ` and matchesPattern('fileInfo.extends.resource.label','.*${queryStr}*')`;
      }
      apiAxios.apmSyncPost("api000158", params, {}, _res => {
        if (_res.code == 200) {
          if (cb) {
            let restaurants = [];
            _res?.data?.records.forEach(_d => {
              let _tags = Object.keys(_d.tags);
              //证券品种GE8000005E  业务场所GE8000004E  业务板块GE8000006E
              let _placeTag = _tags.find(_t => _t.startsWith('GE8000004E_'));
              let _plateTag = _tags.find(_t => _t.startsWith('GE8000006E_'));
              let _firstTypeTag = _tags.find(_t => _t.startsWith('GE8000031E_'));
              let _o = _d;
              _o.value = _d.fid;
              _o.placeTag = _placeTag.slice('GE8000004E_'.length);
              _o.plateTag = _plateTag.slice('GE8000006E_'.length);
              _o.firstTypeTag = _firstTypeTag.slice('GE8000031E_'.length);
              restaurants.push(_o);
            })
            cb(restaurants);
          }
          if (_res)
            res(_res?.data?.records);
        }
      });
    },
    handleSelect(item) {
      this.viewValue = item.label;
      this.curSelect = item;
      this.hasGoPageAuth = true;
      // this.pageFinished();
    },
    onValueClear() {
    },

    showDialog() {
      this.curSelect = "";
      this.devTemplateHistoryList = JSON.parse(localStorage.getItem('templatesHistory')) || [];
      this.dialogTemplateVisible = true;
      this.hotData();
    },
    changeTab(val) {

      for (let k in this.arrTab) {
        if (this.arrTab[k].value == val) {
          this.arrTab[k].active = true
          this.curTab = val
          // this.placeholder = this.arrTab[k].placeholder
          this.curLexicon = this.arrTab[k].lexicon
          this.curSelect = "";
        } else {
          this.arrTab[k].active = false
        }
      }

    },
    //点击历史模板
    btnHistoryPageTo(item) {
      this.curSelect = item;
      this.viewValue = item.label;
      this.hasGoPageAuth = true;
      // this.$EventBus.$emit("selectTemplate", { fid: this.curSelect.fid, label: this.curSelect.label });
      // this.pageFinished();
      // this.dialogTemplateVisible = false;
    },
    /**
     * 点击热门模板
     * @param {*} item
     */
    btnHotpageTo(item) {
      this.curSelect = item;
      this.viewValue = item.label;
      this.hasGoPageAuth = true;
      // this.pageFinished();
    },
    //获取热门数据
    hotData(item) {
      if (config.active != 'prod') {
        this.hotDevTemplates = [
          {
            "fid": "f9bbe0c2ec8cbd217aed699702cff0f5",
            "id": "f9bbe0c2ec8cbd217aed699702cff0f5",
            "label": "深主板2023年三季度报告证券类"
          },
          {
            "fid": "0373f348a9214337990b8c6c01282758",
            "id": "0373f348a9214337990b8c6c01282758",
            "label": "2022深主板半年度报告一般类"
          },
          {
            "fid": "3d761c099127b9759b7258379c5707a0",
            "id": "3d761c099127b9759b7258379c5707a0",
            "label": "2023年QR3主板一般类模板"
          }
        ];
      } else {
        this.hotDevTemplates = [
          {
            "fid": "492939256ca504a24b0bbc4d78e7057b",
            "id": "492939256ca504a24b0bbc4d78e7057b",
            "label": "深主板年度报告（2022年一般类）"
          },
          {
            "fid": "1159d5fa4398234b0ffdf03d1c32a2a8",
            "id": "1159d5fa4398234b0ffdf03d1c32a2a8",
            "label": "创业板三季度报告（2022年创业板）"
          },
          {
            "fid": "7e20d10c5ad3e44950c688c127879617",
            "id": "7e20d10c5ad3e44950c688c127879617",
            "label": "深主板三季度报告（2022年一般类）"
          }
        ];
      }

    },
    // 跳转，关闭弹窗
    pageFinished() {
      this.isLoading = true;
      let _tplInfo = this.readerTpls.find(_d => _d._id == this.tplSelected);
      if (_tplInfo) {
        apiAxios.apmSyncPost('api000187', {
          "fid": _tplInfo.fid,
          "path": "usys/products/release"
        }, {}, _r => {
          if (_r?.data?.path) {
            userDocApi.getFileContextByPath(_r?.data?.path, 'application/json', _r => {
              if (_r.data) {
                let _element = new DOMParser().parseFromString(_r.data, 'text/html');
                let _dom = _element.querySelector('gwc-app-perspective');
                let _req = [];
                _dom.getAttributeNames().map(_k => {
                  _req.push(`${_k}=${_dom.getAttribute(_k)}`);
                })
                this.readerSrc  = `https://ea.cmdp.cn/reader-v2/reader/perspective?${_req.join('&')}`;
                this.isLoading = false;
                this.dialogTemplateVisible  = false;
              } else {
                this.$message.error('读取模板失败！');
                this.isLoading = false;
              }
            })
          } else {
            this.$message.error('读取模板失败！');
            this.isLoading = false;
          }
        })
      } else {
        this.$message.error('读取模板失败！');
        this.isLoading = false;
      }
      return;
      this.isLoading = true;
      // 缓存处理
      let curTab = this.curTab;
      let historylist = []
      let lckey = ""
      if (curTab == 'devTemplate') {
        lckey = "templatesHistory"
        historylist = this.devTemplateHistoryList;

        let params = {
          fid: this.curSelect.fid,
          dir: 'usys/factory/factor/template/release'
        }
        apiAxios.apmSyncPost("api000164", params, {}, _res => {
          if (_res.code == 200 && _res.data) {
            let rst = _res.data;
            if (rst.cat_chapter && rst.cat_html && rst.ctx_tpl) {
              this.templateName = this.curSelect.label;
              this.raw.cat_chapter = rst.cat_chapter;
              this.raw.cat_html = rst.cat_html;
              this.raw.ctx_tpl = rst.ctx_tpl;
              this.raw.meta_element = rst.meta_element;

              let curObj = {fid: this.curSelect.fid, label: this.curSelect.label, ctime: $func.getToday(true)}
              // 为空，直接插入
              if (historylist.length == 0) {
                historylist.push(curObj)
              } else {
                // 是否已存在，存在则替换
                let index = historylist.findIndex(x => x.fid == curObj.fid);
                if (index > -1) {
                  historylist = historylist.splice(index, 1)
                }
                // 超过10，
                if (historylist.length == 10) {
                  historylist = historylist.splice(9, 1)
                }
                historylist.unshift(curObj);
              }


              localStorage.setItem(lckey, JSON.stringify(historylist))

              this.$EventBus.$emit("selectTemplate", {templateName: this.templateName, raw: this.raw});
              this.dialogTemplateVisible = false;
            } else {
              this.$message.error('选择的模板有问题！');
            }
          } else {
            this.$message.error('选择的模板有问题！');
          }
          this.isLoading = false;
        });
      }
    },

    getReaderList() {
      apiAxios.post(`${config.ssovfsUrl}product/list`, {
        "userId": sessionStorage.getItem("USER_ID")
      }, _r => {
        this.readerTpls = Array.from(JSON.parse(_r.data).filter(_r => Object.keys(_r?.tags || {}).includes('prod_小智透视')) || []);
        this.isLoading  = false;
      })
    }
  },
  mounted() {
    this.getReaderList();
  },
  watch: {},
}
</script>

<style lang="less" scoped>
@import "~@/assets/skin/var.less";

// z-index: 999;
.select-template-dialog {
  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }
}

.title-center {
  text-align: center;
  font-size: 18px;
}

.main-content {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  flex: 1;
  // padding-top: 10px;
  height: 300px;
  // background-position: 50%;
  background-size: cover;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .8);
  opacity: .9;

  .header-icon {
    color: white;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;

    i {
      float: right;
    }
  }

  .contentHeader {
    // background-color: #eeeef4;
    padding: 0 10px 10px;
    width: 90%;
    margin: 0 auto;
    text-align: center;

    .main-title {
      display: inline-block;
      margin-bottom: 33px;
      // margin-top: 36px;
      font-size: 48px;
      line-height: 64px;
      letter-spacing: 8px;
      text-indent: 7px;
      color: @workbench-background-color;
    }

    .tab-main {
      .tab-item {
        .tab {
          display: inline-block;
          width: 80px;
          padding: 3px 6px;
          line-height: 1.4;
          margin-right: 32px;
          margin-bottom: 14px;
          border-radius: 2px;
          font-size: 16px;
          background-color: transparent;
          cursor: pointer;
          color: @workbench-background-color;

          .txt {
            position: relative;
          }

          &.active {
            color: #0084ff;
            background-color: @workbench-background-color;

            .txt {
              &:after {
                position: absolute;
                left: 35%;
                top: 100%;
                content: '';
                width: 0;
                height: 0;
                margin-top: 2px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid @workbench-background-color;
              }
            }
          }

          &:hover {
            color: #0084ff;
            background-color: @workbench-background-color;

            .txt {
              &:after {
                position: absolute;
                left: 35%;
                top: 100%;
                content: '';
                width: 0;
                height: 0;
                margin-top: 2px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid @workbench-background-color;
              }
            }
          }
        }
      }
    }

    .search-area {
      .el-select {
        width: 100%;
      }

      .search-btn {
        margin-left: 10px;
      }

      .el-button--primary {
        color: #fff;
        background-color: #26bce2;
        border-color: #26bce2;
      }

      .el-button--primary:focus, .el-button--primary:hover {
        color: #f0f7fc;
        background-color: #2ea4e2;
        border-color: #2ea4e2;
      }
    }

    .hotsearch {
      width: 100%;
      height: 56px;
      margin-top: 32px;
      text-align: left;
      font-size: 0;
      color: @workbench-background-color;
      overflow: hidden;

      .title {
        display: inline-block;
        height: 56px;
        border-radius: 4px;
        overflow: hidden;
        padding-top: 5px;
        text-align: center;
        font-size: 16px;
        letter-spacing: 4px;
        text-indent: 4px;
        line-height: 22px;
        background: @cmew-hotsearch-title-background;
      }

      .keys {
        padding-left: 20px;
        display: inline-block;
        height: 56px;
        vertical-align: top;
        text-align: left;

        .el-link {
          color: #font-color[light];
          display: inline-block;
          vertical-align: top;
          margin-right: 24px;
          margin-bottom: 10px;
          font-size: #font-size[normal];
          line-height: 22px;

          &:hover {
            color: @workbench-background-color !important;
          }
        }
      }
    }


  }

  .cursearch {
    width: 100%;
  }

}

.reader-box {
  width: 100vw;
  height: 100vh;
}
</style>
<style lang="less">
.v-modal {
  background: rgba(0, 0, 0, .1);
}
</style>